import { Component, OnInit } from '@angular/core';
import { FormButton, FormButtonEvent } from '../../../core/components/form-field-button/form-field-button.component';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { Item } from '../../../core/components/listbox/listbox.component';
import { Tab } from '../../../core/components/tabs/tabs.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { ModalService } from '../../../core/services/modal.service';

@Component({
    selector: 'tt-do-data-imps-wizard',
    templateUrl: './do-data-imps-wizard.component.html',
    styleUrls: ['./do-data-imps-wizard.component.css'],
})
export class DoDataImpsWizardComponent implements OnInit {
    public get?: DoDataImpsWizardGet;
    public bspList: Item[] = [];
    public bspWizardList: BspWizardItem[] = [];
    public bspButtons: FormButton[];
    public tabs: DoDataImpTab[] = [];
    public grid?: GridOptions;
    public selectedImp?: number;

    constructor(private datatask: DataTaskService, private modal: ModalService) {
        this.bspButtons = [
            {
                id: 'new',
                icon: 'fas fa-plus',
                type: 'primary',
                tooltip: 'new',
                onClick: (event) => this.createOrEditWizard(event, true),
            },
            {
                id: 'edit',
                icon: 'fas fa-edit',
                type: 'primary',
                tooltip: 'edit',
                onClick: (event) => this.createOrEditWizard(event, false),
                //onClick: (event) => this.modal.openReportPreviewDialog({ heading: event.item.item_name, p2_reportdef_keyno: event.item.p2_reportdef_keyno, report_type_keyno: event.item.report_type_keyno, parameters: { [this.params!.argtype]: this.params!.argvalue } }),
            },
        ];

        //First button adds a new wizard list
        //Second button edits a current list

        //The buttons open up a modal with a place for keyno, the name of the list and list of dataimps (selected or not)
        //After the save, call the same procedure to insert if keyno = 0, and update if != 0
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3853))[0];

        if (!this.get) return;

        //Initial default values
        this.get.bsp_keyno ||= '0';
        this.get.bsp_wizard_keyno ||= '0';
        this.get.tab ||= '0';
    }

    private async loadBspList() {
        this.bspList = await this.datatask.Post(3333);
    }

    public async loadBspWizardList(continueLoad = false, reverse = false) {
        if (!this.get || this.get.bsp_keyno === '0') return;
        this.bspWizardList = await this.datatask.Post(3854, { bsp_keyno: this.get.bsp_keyno });

        //console.log('this.bspWizardList');
        //console.dir(this.bspWizardList);

        let foundIndex: number = -1;
        if (!reverse) {
            for (let i = 0; this.bspWizardList.length > i; i++) {
                if (this.bspWizardList[i]['bsp_wizard_keyno'] === this.get.bsp_wizard_keyno) {
                    foundIndex = i;
                    break;
                }
            }
        }
        if (foundIndex === -1) this.get.bsp_wizard_keyno = reverse ? '' + this.bspWizardList[this.bspWizardList.length - 1]['bsp_wizard_keyno'] : '' + this.bspWizardList[0]['bsp_wizard_keyno'];

        if (continueLoad) this.loadDoDataImpTabs(true);
    }

    public async loadDoDataImpTabs(continueLoad = false) {
        if (!this.get) return;
        if (this.get.bsp_wizard_keyno === '0') {
            this.tabs = [];
            delete this.selectedImp;
            return;
        }

        this.get.tab = '0';
        this.tabs = (await this.datatask.Post(3855, { bsp_wizard_keyno: this.get.bsp_wizard_keyno })).map((item: DoDataImpItem, index: number) => <Tab>{ ...item, id: '' + index, label: item.dataimp_name, translateLabel: false });

        if (continueLoad) this.createGrid();
    }

    public createGrid() {
        //console.log('Create Grid');

        if (!this.get || this.tabs.length === 0) return;

        this.selectedImp = parseInt(this.tabs[parseInt(this.get.tab)].dataimp_keyno);

        //this.grid = new Grid();
        //console.log(this.tabs[parseInt(this.get.tab)].label, ' loaded');
        //console.dir(this.get);
    }

    private async createOrEditWizard(event: FormButtonEvent, isNew: boolean) {
        //console.log(event);
        if (!this.get) return;

        //if (!isNew) this.showLogs();

        //const params = `${this.get.bsp_keyno}/${isNew ? '0' : this.get.bsp_wizard_keyno}`;
        const params = this.get.bsp_keyno + '/' + (isNew ? '0' : this.get.bsp_wizard_keyno);

        const response = await this.modal.openStateDialog({ state: 'dodataimpswizardedit', params: params });

        //console.log('value: ', response, ' type: ', typeof response);

        if (response !== undefined) {
            if (response === '0' || response === 0) {
                //console.log('truetrue');
                this.loadBspWizardList(true, true);
            } else {
                //console.log('nah');
                this.loadBspWizardList(true);
            }
        }
    }

    private showLogs() {
        console.dir(this.get);
        console.dir(this.bspList);
        console.dir(this.bspWizardList);
        console.dir(this.tabs);
    }

    public wizardPrevious() {
        //this.showLogs();

        if (!this.get) return;

        this.get.tab = (parseInt(this.get.tab) - 1).toString();

        this.createGrid();
    }

    public wizardNext() {
        if (!this.get) return;

        this.get.tab = (parseInt(this.get.tab) + 1).toString();

        this.createGrid();
    }

    public wizardFinish() {
        if (!this.get) return;

        //console.log('FINISH');
    }

    async ngOnInit() {
        await this.loadGet();
        if (!this.get) return;
        this.loadBspList();
        this.loadBspWizardList();
        this.loadDoDataImpTabs();
        this.createGrid();

        //this.showLogs();
    }
}

interface DoDataImpsWizardGet {
    bsp_keyno: string;
    bsp_wizard_keyno: string;
    tab: string;
}

interface BspWizardItem {
    bsp_wizard_keyno: string;
    bsp_wizard_name: string;
    orderby: string;
}

interface DoDataImpItem {
    dataimp_keyno: string;
    dataimp_name: string;
    orderby: string;
}

type DoDataImpTab = Tab & DoDataImpItem;
